import request from "@/lib/request/request";
import Model from "../model";

export class LogSearchForm extends Model {
  examId = 0;
  mobileSendStatusList: number[] = [];
  emailSendStatusList: number[] = [];
  env: number[] = [];
  searchKey = "";
  page = 1;
  pageSize = 10;
  companyId = 0;
}

export interface BatchSendParams {
  companyId: string;
  logIdList: number[];
  sendMobile: boolean;
  sendEmail: boolean;
}

export class SendParam extends Model {
  logId = 0;
  sendMobile = false;
  sendEmail = false;
}

export class LogNew extends Model {
  static getList(params: LogSearchForm) {
    return request
      .postInterviewApi("/hr/messageLog/list", params)
      .then(resp => resp.data);
  }

  static sendEmail(id: number) {
    return request
      .postInterviewApi("/hr/messageLog/send", {
        id,
        sendMobile: false,
        sendEmail: true
      })
      .then(resp => resp.data);
  }

  static sendMobile(id: number) {
    return request
      .postInterviewApi("/hr/messageLog/send", {
        id,
        sendMobile: true,
        sendEmail: false
      })
      .then(resp => resp.data);
  }

  static sendAsk(params: SendParam) {
    return request
      .postInterviewApi("/hr/messageLog/send", params)
      .then(resp => resp.data);
  }

  static batchSend(params: BatchSendParams) {
    return request
      .postInterviewApi("/hr/messageLog/mSend", params)
      .then(resp => resp.data);
  }

  static getAllIds(params: LogSearchForm) {
    return request
      .postInterviewApi("/hr/messageLog/listIds", params)
      .then(resp => resp.data);
  }
}
